import React from "react";
import HOC from "../../components/HOC";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";
import BillingBreadcrumb from "../../components/screen/billing/BillingBreadcrumb";
import OnlineBillingDetail from "../../components/screen/billing/OnlineBillingDetail";

const OnlineBillingDetailPage = ({ isPbf }) => {
  return (
    <div className="">
      <PageTemplate
        header={`Detail Billing Online ${isPbf ? "PBF" : ""}`}
        mainComponent={
          <ThemeProvider theme={theme}>
            <OnlineBillingDetail isPbf={isPbf ? isPbf : false} />
          </ThemeProvider>
        }
        pageRole={7}
        breadcrumb={<BillingBreadcrumb />}
      />
    </div>
  );
};

export default HOC(OnlineBillingDetailPage);
